import React from 'react';
import { View, ImageBackground, ScrollView, SafeAreaView } from 'react-native';

import { t } from 'Locale';
// eslint-disable-next-line import/no-unresolved
import { Button, ModalHeader } from 'LocalGluons';
import { Device } from 'DeviceUtils';
import defaultStyles from './CanalplusAboutService.jss';

interface CanalPlusAboutServiceProps {
    route: any;
    navigation: any
}

const CanalPlusAboutService = ({ route }: CanalPlusAboutServiceProps): React.ReactElement => {
    const { close } = route.params;
    return (
        <SafeAreaView style={defaultStyles.safeAreaContainer}>
            <ScrollView contentContainerStyle={defaultStyles.scrollContainer}>
                <ImageBackground
                    source={{
                        uri: Device.isTabletOrWeb
                            ? t('PARTNER.CANALPLUS.ABOUT.IMG_URL_TABLET_WEB')
                            : t('PARTNER.CANALPLUS.ABOUT.IMG_URL_MOBILES')
                    }}
                    style={defaultStyles.imageBackground}
                    resizeMode='cover'
                >
                    <View style={defaultStyles.container}>
                        <ModalHeader
                            style={{
                                iconContainer: defaultStyles.iconCloseContainer
                            }}
                            onPress={close}
                        />
                        {/* <View style={defaultStyles.buttonContainer}> */}
                        <Button
                            onPress={close}
                            style={{
                                button: {
                                    ...defaultStyles.button,
                                    ...defaultStyles.buttonContinue
                                }
                            }}
                            title={t('PARTNER.CANALPLUS.I_UNDERSTAND_BTN')}
                        />
                        {/* </View> */}
                    </View>
                </ImageBackground>
            </ScrollView>
        </SafeAreaView>
    );
};

export default CanalPlusAboutService;
